const generateSalt = (length: number = 6): string => {
  return Math.random()
    .toString(36)
    .substring(2, 2 + length);
};

const simpleHash = (str: string, length: number = 6, salt: string = ""): { hash: string } => {
  let hash = 1000;

  const input = str + salt;

  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) + hash + input.charCodeAt(i);
  }

  const hashString = (hash >>> 0).toString();

  return { hash: hashString.length >= length ? hashString.slice(0, length) : hashString.padStart(length, "0") };
};

const simpleHashWithRandomSalt = (str: string, length: number = 6): { hash: string; salt: string } => {
  const salt = generateSalt();
  const { hash } = simpleHash(str, length, salt);

  return { hash, salt };
};

export { simpleHashWithRandomSalt, simpleHash, generateSalt };
